import { render, staticRenderFns } from "./SendHttp.vue?vue&type=template&id=22c13780&scoped=true"
import script from "./SendHttp.vue?vue&type=script&lang=js"
export * from "./SendHttp.vue?vue&type=script&lang=js"
import style0 from "./SendHttp.vue?vue&type=style&index=0&id=22c13780&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c13780",
  null
  
)

export default component.exports